import * as React from "react";
import axios from 'axios';
import { EditorState,convertFromRaw,convertToRaw } from 'draft-js';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./CardObject.css"
//import '../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import { Intent, Classes } from "@blueprintjs/core";
import { Button,ButtonGroup, Card, Elevation, Overlay,H4 } from "@blueprintjs/core";
import{HomeProps} from './Home.tsx'


import {Toaster, Position} from "@blueprintjs/core";
const toaster=Toaster.create({
  className: "my-toaster",
  position: Position.TOP_RIGHT
});


export default class CardEditor extends React.Component  <HomeProps> {
  state = {
    name: '',
    force_height:'240px',
    force_height2:'480px',
    force_width:'360px',
    parent_height:480,
    isOpenEdit:false,
    isOpenDelete:false,
    title_document_creation:'',
    description_document_creation:'',
    objectif_document_creation:'',
    typeflex:'initial',
    status_published:"eye-off",
    youtube_frame:'',
    showcontenu:'block',
    url_video:'',
    elargir:'arrow-right',
    url_video2:'',
    editorState: EditorState.createEmpty(),
    isOpenEditor:false,
    isSaveEditor:false,
    tailletexte:0,
    contenu:'',
    recordingsbydate:'',
    is_upload:false
  }  
 
  
  constructor(props) {
        super(props);
        if(this.props.handleEdition!=undefined)this.props.handleEdition.bind(this);
       // this.handleChange = this.handleChange.bind(this);
      }
  componentDidMount () { 
   var that=this;
   this.setState({title_document_creation:this.props.title_document});
   this.setState({description_document_creation:this.props.description});
   this.setState({objectif_document_creation:this.props.objectif})
   this.setState({youtube_frame:this.props.youtube_frame});
   this.setState({url_video:this.props.url_video});
   window.addEventListener("message", this.handlerMessageiframe);
   var host=window.location.toString();
   var ll=host;
   if(ll.split('https:').length>1)host="";
   if(ll.split('http:').length>1)host="";
   
    if(this.props.type_audio =='true') {
      this.setState({force_height:'80px'}); 
      this.setState({loadthegraph:'needloaded'})
    }
    this.setState({parent_height:480})
    if(this.props.type_audio =='true') this.setState({typeflex:'100%'})
    else this.setState({typeflex:'initial'})
       
  /*  if(this.props.config =='true') {
      this.setState({force_width:'480px'});
    }*/
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(this.props.recordingsbydate==undefined)return;
    if(this.state.recordingsbydate!=this.props.recordingsbydate)
    {
      this.setState({recordingsbydate:this.props.recordingsbydate})
      {
        this.props.recordingsbydate.map((item)=>
        {
          item.recordings.map((it)=>{
            if(it.type=="text")
            {
              if (it.data.includes(this.props.userid+"_"+this.props.id_document+".jsontext"))
              {
                console.log("a charger");
                this.loadText(it.data);
              }
            }
          })
        });
      }
    }
    
  }
  loadText=(url)=>
  {
   
    //url=url+"&timestamp="+new Date().getTime();  
    axios.get(url, {
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
          'Content-Type': 'application/json'
        },
        responseType: "json"
      })
        .then(response => {
         
          console.log(response.data);
          const rawContent = convertFromRaw(response.data);
          this.setState({ editorState: EditorState.createWithContent(rawContent) })
        })
      /*  .catch(err => {
          console.log("error", err);
        });*/
  }

  onEditorStateChange: Function = (editorState) => {
    this.setState({
      editorState,
    });    
  };
  onContentStateChange: Function = (contentState) => {
    this.setState({
      contentState,
    });
    var contentState2=this.state.editorState.getCurrentContent()
    var contenu_=JSON.stringify(convertToRaw(contentState2));//, null, 4)
    console.log(contenu_);
    if(this.state.tailletexte!=contenu_.length){this.setState({tailletexte:contenu_.length});this.setState({contenu:contenu_});this.setState({isSaveEditor:true});}
    
  };
  sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
  }
  AjouterDocumentAsync=async (item)=>{
    this.AjouterDocument(item);
    await this.sleep(2000);
    this.props.fromChildren("loadstudentdocument" ,this.props.userid);
  }
  AjouterDocument=(item)=>{
    
    var xhr = new XMLHttpRequest();
        xhr.overrideMimeType("application/json");
       
       var that=this;
        var form = new FormData();
        var date1=new Date();
        var stdate=date1.toLocaleString('fr-FR',{weekday:'long',year:'numeric',month:'long',day:'numeric',hour:'numeric',minute:'numeric',second:'numeric'});
       
        form.append("ordre", "depotfromstudent");
        form.append("id_student", this.props.userid);
        form.append("id_matiere", this.props.matiere_id);
        form.append("id_document", this.props.id_document);
        form.append("title", this.props.title_document);
        form.append("date_record", stdate);
        form.append('url', item.filename);
        form.append("type", item.typedufichier);
        const response=  fetch('/api/public/createdocumentstudent', {
          // credentials: "include",
           method: "POST",
           body: form,
         });
         return;
        /*formData.append('id_cours', this.props.id_cours);
        formData.append('url', item.filename);
        formData.append('title', this.state.title_document_creation);
        formData.append('objectif', this.state.objectif_document_creation);
        formData.append('description', this.state.description_document_creation);
        formData.append('publication',"depot");
        formData.append('type',item.typedufichier);
        formData.append('tag', this.props.id_cours);*/
        
             
        xhr.open('POST','/api/public/createdocumentstudent')
        xhr.setRequestHeader("Content-Type", "application/json");

        //xhr.send(JSON.stringify(Object.fromEntries(form)));
        //xhr.send(Object.fromEntries(form));

        xhr.onreadystatechange = function() {
            if (xhr.readyState == XMLHttpRequest.DONE) {
             //if(xhr.status==200) {that.LoadDataDocumentsDirect(that.props.id_cours);toaster.show( {icon:'document-open', intent:Intent.SUCCESS,timeout:2000,message:"Le document "+that.state.title_document_creation+" est ajouté"});that.setState({openCreationDocument:false});}
             if(xhr.status==500) {toaster.show( {icon:'document-open', intent:Intent.DANGER,timeout:3000,message:"erreur document non créé"}); }
             //setUserPassword({})
            
            }
           
        }
  }
  handlerMessageiframe = event => 
  {
     if(this.state.is_upload==false)return;
     console.log("from carddocumentsenseignants:"+event);
     if(event.data.payload!=undefined)return;
     const data = JSON.parse(event.data)
     if(data.message=="uploaded")
     {
       if(data.files.length>0)
       {
         var num=0;
         data.files.forEach((item)=>{
           //var filename=item.filename;
           num++;
           this.setState({title_document_creation:'Document '+num});
           this.setState({istypeaudio:'false'});
           if(item.typedufichier=='office')item.typedufichier='object'
           this.setState({type_document_creation:item.typedufichier})
           if((item.typedufichier=="audio")||(item.typedufichier=="video"))
           {
             this.setState({is_inputmedia:true});
             this.setState({url_saisie:item.filename});
           }
           if((item.typedufichier=="pdf"))
           {
             this.setState({is_inputpdf:true});
             this.setState({url_saisie:item.filename});
           }
           if((item.typedufichier=="image"))
           {
             this.setState({is_inputimage:true});
             this.setState({url_saisie:item.filename});
           }
           if((item.typedufichier=="object"))
           {
             this.setState({is_inputother:true});
             this.setState({url_saisie:item.filename});
           }
           if((item.typedufichier=="text"))
           {
             this.setState({is_inputother:true});
             this.setState({url_saisie:item.filename});
           }
           if(item.typedufichier=="audio")this.setState({istypeaudio:'true'});
           this.AjouterDocumentAsync(item);
           this.setState({is_upload:false});
          
           toaster.show( {icon:'document', intent:Intent.SUCCESS,timeout:5000,message:"Le fichier "+item.filename+" est téléversé. Taille du fichier:"+item.size/(1024*1024)+"Mo"});
         });
         this.setState({isOpen:false});
       }
       else
       {
           var filename=data.filename;
           this.setState({istypeaudio:'false'});
           this.setState({type_document_creation:data.type})
           if((data.type=="audio")||(data.type=="video"))
           {
             this.setState({is_inputmedia:true});
             this.setState({url_saisie:data.filename});
           }
           if((data.type=="pdf"))
           {
             this.setState({is_inputpdf:true});
             this.setState({url_saisie:data.filename});
           }
           if((data.type=="image"))
           {
             this.setState({is_inputimage:true});
             this.setState({url_saisie:data.filename});
           }
           if((data.type=="object"))
           {
             this.setState({is_inputother:true});
             this.setState({url_saisie:data.filename});
           }
           if((data.type=="text"))
           {
             this.setState({is_inputother:true});
             this.setState({url_saisie:data.filename});
           }
           if(data.type=="audio")this.setState({istypeaudio:'true'});
           this.setState({is_upload:false});
           this.setState({openCreationDocument:true});
           
           toaster.show( {icon:'document', intent:Intent.SUCCESS,timeout:5000,message:"Le fichier "+data.filename+" est téléversé. Taille du fichier:"+data.size/(1024*1024)+"Mo"})
       }
         
     }
     console.log("message from iframe depuis cours id:"+this.props.id_cours, data)
   }

   componentWillUnmount(): void {
    window.removeEventListener("message", this.handlerMessageiframe)
 }

   render() {
    const { editorState } = this.state;
    const {type_audio,title_document,description,objectif,isnotdocument,navFiles,state,isnotconnected,menuVisibility,isOpenSign,usernickname,isOpenLogin,handleOpenVisio,handleOpen,handleClose,handleChange,handleSendCnx,handleSelectionChange,handleSelectionGetLogin,handleOpenLogin,handleCloseLogin,handleChangeLogin,handleSendCnxLogin}=this.props;
    
   
    

    return(
     this.props.userid!=undefined?<div>
     
     {this.props.toolbar!='true'?<Button onClick={(ev)=>
      {
        ev.preventDefault();
        this.props.handletaille();
        if(this.state.isOpenEditor==false) this.setState({isOpenEditor:true});
        else  this.setState({isOpenEditor:false});
      }}
      className={(!this.state.isOpenEditor?Classes.OUTLINED:"") +" "+ Classes.LARGE +" "+ Classes.INTENT_SUCCESS} icon="edit" title="Editer" />:null}

     {this.state.isSaveEditor ==true?<Button onClick={(ev)=>
      {
        ev.preventDefault();
        this.setState({isSaveEditor:false});
        this.props._onUploadtext( this.state.contenu,this.props.id_document,this.props.title_document);
      }}
      className={Classes.OUTLINED +" "+ Classes.LARGE} intent={Intent.DANGER} icon="floppy-disk" title="Sauvegarder" />:null}
     <Button className={(!this.state.is_upload?Classes.OUTLINED:"") +" "+ Classes.LARGE +" "+ Classes.INTENT_WARNING} icon="cloud-upload" title="Déposer un document" onClick={(ev)=>{ev.preventDefault();this.setState({is_upload:!this.state.is_upload});this.props.handletaille();}}/>
     {this.props.toolbar=='true'?<Button onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:true});}} className={Classes.OUTLINED+" "+ Classes.INTENT_DANGER +" " + Classes.LARGE} icon="trash" title="Effacer" />:null}
    
     {this.state.is_upload ? <iframe style={{marginTop:5,border:0,width:'100%',height:'530px'}} src='upload/index.html'></iframe>:<div></div>}
     {this.state.isOpenEditor?<div>{this.props.title_document}<br/><Editor
      editorState={editorState}
      toolbarClassName="toolbarClassName"
      wrapperClassName="wrapperClassName"
      editorClassName="editorClassName"
      toolbar={{options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker',  'history'],
        inline: { inDropdown: true },
        list: { inDropdown: true },
        textAlign: { inDropdown: false },
        history: { inDropdown: false },
      }}
      onEditorStateChange={this.onEditorStateChange}
      onContentStateChange={this.onContentStateChange}
    /></div>:null}
     </div>:null
    );
}
}
